// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AAf2I","mainContainer":"styles_mainContainer__8tzNE","card":"styles_card__Xwy44","button":"styles_button__IIKnL"};